;(() => {
	const instances = new Map();
	const activeSlideIndices = new Map();
	let isDesktopState = window.innerWidth > 749;

	const getSectionId = (section) => {
		return section.id || 'default-case-studies';
	};

	const destroySlider = (section) => {
		const sectionId = getSectionId(section);
		const instance = instances.get(sectionId);
		
		if (instance) {
			if (instance.caseSwiper) {
				instance.caseSwiper.destroy(true, true);
			}
			if (instance.thumbsSwiper) {
				instance.thumbsSwiper.destroy(true, true);
			}
			if (instance.resizeObserver) {
				instance.resizeObserver.disconnect();
			}
			if (instance.resizeHandler) {
				window.removeEventListener('resize', instance.resizeHandler);
			}
			instances.delete(sectionId);
		}

		// Clean up Swiper legacy inline styles from container, wrapper, and slides
		const clearSwiperStyles = (el) => {
			if (!el) return;
			el.removeAttribute('style');
			const wrapper = el.querySelector('.swiper-wrapper');
			if (wrapper) wrapper.removeAttribute('style');
			const slides = el.querySelectorAll('.swiper-slide');
			slides.forEach(slide => slide.removeAttribute('style'));
		};

		clearSwiperStyles(section.querySelector('.case-studies__slider'));
		clearSwiperStyles(section.querySelector('.case-studies__thumbs'));
	};

	const getThumbsParams = (layout, caseThumbsSlider) => {
		const swiperParamsThumbs = {
			freeMode: true,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
			on: {
				touchEnd(s) {
					const range = 5;
					const diff = s.isHorizontal()
						? s.touches.currentX - s.touches.startX
						: s.touches.currentY - s.touches.startY;
					if (diff < range || diff > -range) {
						s.allowClick = true;
					}
				},
			},
		};

		if (layout === 'tabs_bottom') {
			swiperParamsThumbs.slidesPerView = 'auto';
			swiperParamsThumbs.spaceBetween = 24;
			swiperParamsThumbs.direction = 'horizontal';
			swiperParamsThumbs.breakpoints = {
				750: { spaceBetween: 24 },
				990: { spaceBetween: 40 },
				1360: { spaceBetween: 88 },
			};
		}

		if (layout === 'tabs_left') {
			const slidesCount = caseThumbsSlider.querySelectorAll('.swiper-slide').length || 4;
			swiperParamsThumbs.slidesPerView = slidesCount;
			swiperParamsThumbs.spaceBetween = 24;
			swiperParamsThumbs.direction = 'vertical';
			swiperParamsThumbs.breakpoints = {
				320: {
					direction: 'horizontal',
					slidesPerView: slidesCount,
				},
				750: {
					direction: 'vertical',
					slidesPerView: slidesCount,
				}
			};
		}

		return swiperParamsThumbs;
	};

	const initSlider = (section) => {
		const sectionId = getSectionId(section);
		destroySlider(section);

		const caseSlider = section.querySelector('.case-studies__slider');
		if (!caseSlider) return;

		const caseThumbsSlider = section.querySelector('.case-studies__thumbs');
		const layout = caseSlider.getAttribute('data-layout');
		const enableNavigation = caseSlider.getAttribute('data-navigation') === 'true';

		// Initialize thumbs if required
		let thumbsSwiper = null;
		const shouldInitThumbs = !!caseThumbsSlider;
		if (shouldInitThumbs) {
			const thumbsParams = getThumbsParams(layout, caseThumbsSlider);
			thumbsSwiper = new Swiper(caseThumbsSlider, thumbsParams);
		}

		// Initialize main slider
		const initialSlide = activeSlideIndices.get(sectionId) || 0;
		const swiperParams = {
			initialSlide,
			spaceBetween: 16,
			mousewheel: { forceToAxis: true },
			loopPreventsSliding: false,
			on: {
				slideChange() {
					activeSlideIndices.set(sectionId, this.activeIndex);
					if (this.pagination) {
						this.pagination.render();
						this.pagination.update();
					}
				},
			},
		};

		if (layout === 'tabs_bottom') {
			swiperParams.slidesPerView = 1;
		}

		if (layout === 'tabs_left') {
			swiperParams.slidesPerView = 1;
			swiperParams.speed = 1000;
			swiperParams.breakpoints = {
				750: {
					slidesPerView: 1,
					spaceBetween: 24,
				},
			};
		}

		if (caseSlider.getAttribute('data-pagination') === 'true') {
			const pagination = section.querySelector('.case-studies__pagination');
			if (pagination) {
				swiperParams.pagination = {
					el: pagination,
					type: 'bullets',
					clickable: true,
				};
			}
		}

		if (enableNavigation && (layout === 'tabs_bottom' || layout === 'overlay')) {
			const navigation = section.querySelector('.case-studies__navigation');
			if (navigation) {
				swiperParams.navigation = {
					nextEl: navigation.querySelector('.swiper-button-next'),
					prevEl: navigation.querySelector('.swiper-button-prev'),
				};
			}
		}

		if (thumbsSwiper) {
			swiperParams.thumbs = {
				swiper: thumbsSwiper,
			};
		}

		const caseSwiper = new Swiper(caseSlider, swiperParams);

		let resizeObserver = null;
		let resizeHandler = null;
		if (caseThumbsSlider && thumbsSwiper && layout === 'tabs_left') {
			const updateHeight = () => {
				const isDesktop = window.innerWidth > 749;
				if (isDesktop) {
					requestAnimationFrame(() => {
						if (caseSlider && caseThumbsSlider && thumbsSwiper && typeof thumbsSwiper.update === 'function' && !thumbsSwiper.destroyed) {
							caseThumbsSlider.style.height = `${caseSlider.clientHeight}px`;
							thumbsSwiper.update();
						}
					});
				} else {
					caseThumbsSlider.style.height = 'auto';
					if (thumbsSwiper && typeof thumbsSwiper.update === 'function' && !thumbsSwiper.destroyed) {
						thumbsSwiper.update();
					}
				}
			};

			// Inicializar y observar cambios de tamaño reales en el slider principal
			updateHeight();
			if (typeof ResizeObserver !== 'undefined') {
				resizeObserver = new ResizeObserver(() => {
					updateHeight();
				});
				resizeObserver.observe(caseSlider);
			} else {
				resizeHandler = updateHeight;
				window.addEventListener('resize', resizeHandler);
			}
		}

		instances.set(sectionId, {
			caseSwiper,
			thumbsSwiper,
			resizeObserver,
			resizeHandler,
		});
	};

	const initAll = () => {
		const sections = document.querySelectorAll('.case-studies');
		sections.forEach((section) => {
			const shopifySection = section.closest('.shopify-section') || section;
			initSlider(shopifySection);
		});
	};

	// DOM loaded initialisation
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	// Optimize resize events: only reload if breakpoint 750px crossed
	window.addEventListener('resize', () => {
		const isDesktop = window.innerWidth > 749;
		if (isDesktop === isDesktopState) return;
		isDesktopState = isDesktop;
		initAll();
	});

	// Shopify editor events support
	document.addEventListener('shopify:section:load', (e) => {
		initSlider(e.target);
	});

	document.addEventListener('shopify:section:unload', (e) => {
		destroySlider(e.target);
	});
})();
